<app-pos-spinner [show]="loading"></app-pos-spinner>
<router-outlet></router-outlet>